module.exports = __webpack_public_path__ + "9804c0d6b011f79b050f3572b68d28a7.svg";